import { render, staticRenderFns } from "./YourBusiness.vue?vue&type=template&id=69866d08&scoped=true"
import script from "./YourBusiness.vue?vue&type=script&lang=js"
export * from "./YourBusiness.vue?vue&type=script&lang=js"
import style0 from "./YourBusiness.vue?vue&type=style&index=0&id=69866d08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69866d08",
  null
  
)

export default component.exports